import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  FormGroup,
  Checkbox,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { currencyFormat } from "../../common/components/Utils";

import {
  addOrUpdateTeacher,
  getDistricts,
  getSchoolPositions,
  getShoolTeachers,
} from "../../../../store/posts/actions";
import { isEmpty } from "lodash";
import axios from "axios";
import { CSVLink } from "react-csv";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import moment from "moment";
import { showError, showSuccess } from "../../../toastify";
import defaultPofile from "../../../assets/default-profile.jpg";

import { getProfileDocuments } from "../../../../store/users/actions";

// import { idNumberPattern } from "../../common/components/Utils";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import { Help } from "@mui/icons-material";

/** MSSQL/driver may return PascalCase columns */
function positionTeachingLevelId(position) {
  if (!position || typeof position !== "object") return null;
  const id =
    position.teachingLevelId ?? position.TeachingLevelId ?? undefined;
  return id !== undefined && id !== null && id !== "" ? id : null;
}

function positionTeachingLevelName(position) {
  if (!position || typeof position !== "object") return "";
  return (
    position.teachingLevelName ??
    position.TeachingLevelName ??
    ""
  );
}

const personalEmailValidator = joi.object({
  email: joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: ["com", "fr", "rw"] },
  }),
});

const idNumberPattern = [
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  " ",
  /\d/,
  /\d/,
];

const UpdateTeacherDialog = (props) => {
  const {
    user,
    loading,
    onWait,
    teacher,
    showDialog,
    setShowDialog,
    addOrUpdateTeacher,
    roles,
    districts,
    getDistricts,
    // position,
    degrees,
    specializations,
    schoolPositions,

    placementReport,
    getSchoolPositions,
    getProfileDocuments,

    profileDocumentTypes,
    profileDocuments,
    getShoolTeachers,
    schoolTeachers,
  } = props;

  const onClose = () => {
    setShowDialog(false);
  };

  const { hasPermissions } = useRequiredAuth();

  /**
   * Editability of teacher-profile fields is permission-driven, not role-driven.
   * The SDMS staff code is its own opt-in permission so admins can toggle it
   * for any role through the Roles tab in /in/global-settings without granting
   * the broader EDIT_STAFF_PROFILE permit.
   */
  const canEditSdmsStaffCode = hasPermissions([
    "SCHOOL_MANAGEMENT_STAFF_EDIT_SDMS_STAFF_CODE",
  ]);

  const canEditAppointmentInfo = hasPermissions([
    "SCHOOL_MANAGEMENT_STAFF_EDIT_STAFF_APPOINTMENT_INFO",
  ]);

  const canSaveStaffChanges = hasPermissions([
    "SCHOOL_MANAGEMENT_STAFF_EDIT_STAFF_PROFILE",
    "SCHOOL_MANAGEMENT_STAFF_EDIT_STAFF_APPOINTMENT_INFO",
    "SCHOOL_MANAGEMENT_STAFF_EDIT_SDMS_STAFF_CODE",
  ]);

  const [sectors, setSectors] = useState([]);
  const [cells, setCells] = useState([]);
  const [villages, setVillages] = useState([]);

  const [district, setDistrict] = useState(null);
  const [sector, setSector] = useState(null);
  const [cell, setCell] = useState(null);
  const [village, setVillage] = useState(null);

  const [errors, setErrors] = useState({
    nidNumberHasError: false,
    emailHasError: false,
    phoneNumberHasError: false,
    employeeIdHasError: false,
    staffCodeHasError: false,
    employmentTypeHasError: false,
    bankAccountNumberHasError: false,
    educationCertficateHasError: false,
    positionHasError: false,
    passportNumberHasError: false,

    employmentDateInEducationHasError: false,
    positionAppointmentDateHasError: false,
    hasError: false,
  });

  const [selectedAssignedLevel, setSelectedAssignedLevel] = useState(null);
  const [selectedAssignedSubLevel, setSelectedAssignedSubLevel] =
    useState(null);

  const teacherInfoFormValidator = () => {
    const error = {
      nidNumberHasError: false,
      emailHasError: false,
      phoneNumberHasError: false,
      employeeIdHasError: false,
      staffCodeHasError: false,
      employmentTypeHasError: false,
      bankAccountNumberHasError: false,
      educationCertficateHasError: false,
      positionHasError: false,
      passportNumberHasError: false,

      employmentDateInEducationHasError: false,
      positionAppointmentDateHasError: false,
      hasError: false,
    };

    // console.log(teacherForm.nidNumber.replace(/\s/g, "").length);
    if (
      ((teacherForm.nidNumber || "").replace(/\s/g, "").length !== 16 &&
        (teacherForm.nidNumber || "").replace(/\s/g, "").length !== 10 &&
        !teacherForm.passportNumber) ||
      !!idHasError
    ) {
      error.nidNumberHasError = true;
      error.hasError = true;
    }

    if (
      !!teacherForm.nidNumber &&
      (teacherForm.nidNumber || "").replace(/\s/g, "").length !== 16 &&
      !teacherForm.passportNumber
    ) {
      error.passportNumberHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.employeeId) {
      error.employeeIdHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.sdmsStaffCode) {
      error.staffCodeHasError = true;
      error.hasError = true;
    }

    if ((teacherForm.phoneNumber || "").replace(/\s/g, "").length !== 10) {
      error.phoneNumberHasError = true;
      error.hasError = true;
    }

    if (
      !teacherForm.email ||
      (!!teacherForm.email &&
        personalEmailValidator.validate({ email: teacherForm.email }).error)
    ) {
      error.emailHasError = true;
      error.hasError = true;
    }

    if (!selectedEmploymentType) {
      error.employmentTypeHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.bankId) {
      error.bankAccountNumberHasError = true;
      error.hasError = true;
    }

    if (teacherForm.hasEducationCertficate === "") {
      error.educationCertficateHasError = true;
      error.hasError = true;
    }

    // if (!selectedDegree) {
    //   error.degreeHasError = true;
    //   error.hasError = true;
    // }

    // if (!selectedSpecialization) {
    //   error.specializationHasError = true;
    //   error.hasError = true;
    // }

    if (
      !position
      // ||
      // (!!position &&
      //   +position?.budgetPosts <= +position?.numberOfEmployees &&
      //   position.id !== teacher.schoolPositionId)
    ) {
      error.positionHasError = true;
      error.hasError = true;
    }

    if (
      (!!teacherForm.positionAppointmentDate &&
        moment(teacherForm.positionAppointmentDate).format("yyyy-MM-DD") >
          moment().format("yyyy-MM-DD")) ||
      !teacherForm.positionAppointmentDate
    ) {
      error.positionAppointmentDateHasError = true;
      error.hasError = true;
    }

    if (
      !!teacherForm.employmentDateInEducation &&
      moment(teacherForm.employmentDateInEducation).format("yyyy-MM-DD") >
        moment().format("yyyy-MM-DD")
    ) {
      error.employmentDateInEducationHasError = true;
      error.hasError = true;
    }

    // if (
    //   (!!teacherForm.graduationDate &&
    //     new Date(teacherForm.graduationDate) > new Date()) ||
    //   !teacherForm.graduationDate
    // ) {
    //   error.graduationDateHasError = true;
    //   error.hasError = true;
    // }

    setErrors(error);

    if (error.hasError) {
      return true;
    }
    return false;
  };

  const employmentTypes = [
    { id: 1, name: "Permanent" },
    { id: 2, name: "Contractual" },
  ];

  const [isVerifing, setIsVerifing] = useState(false);
  const [wasVerified, setWasVerified] = useState(teacher.isNIDVerified);
  const [idHasError, setIdHasError] = useState(false);

  const [selectedEmploymentType, setSelectedEmploymentType] = useState(
    employmentTypes.find(({ id }) => id === teacher.employmentTypeId),
  );
  const [selectedDegree, setSelectedDegree] = useState(null);
  const [selectedSpecialization, setSelectedSpecialization] = useState(null);
  const [position, setPosition] = useState(null);

  const [teacherForm, setTeacherForm] = useState({
    nidNumber: teacher.nidNumber,
    passportNumber: teacher.passportNumber,
    nin: teacher.nin,
    email: teacher.email,
    phoneNumber: teacher.phoneNumber,
    gender: teacher.gender,
    genderId: teacher.genderId,
    countryOfBirth: teacher.countryOfBirth,
    countryIdOfBirth: teacher.countryIdOfBirth,
    firstName: teacher.firstName,
    lastName: teacher.lastName,
    civilStatus: teacher.civilStatus,
    civilStatusId: teacher.civilStatusId,
    spouseNames: teacher.spouseNames,
    fatherNames: teacher.fatherNames,
    motherNames: teacher.motherNames,
    dateOfBirth: teacher.dateOfBirth,
    placeOfBirth: teacher.placeOfBirth,
    nationalityId: teacher.nationalityId,
    villageId: teacher.villageId,
    profilePicture: "",
    employeeId: teacher.id,
    rssbNumber: teacher.rssbNumber,
    accountNumber: teacher.accountNumber,
    bankId: teacher.bankId,
    bankName: teacher.bankName,
    sdmsStaffCode: teacher.sdmsStaffCode || teacher.id,
    hasEducationCertficate: teacher.hasEducationCertficate,
    graduationDate: !!teacher.graduationDate
      ? new Date(teacher.graduationDate)
      : null,

    employmentDateInEducation: !!teacher.employmentDateInEducation
      ? new Date(teacher.employmentDateInEducation)
      : null,
    positionAppointmentDate: !!teacher.positionAppointmentDate
      ? new Date(teacher.positionAppointmentDate)
      : null,
  });

  const getNidDetails = async (nidNumber) => {
    try {
      setWasVerified(false);
      setIsVerifing(true);
      // let staff = {};
      // try {
      //   const { data: tmisData } = await axios.get(
      //     "/api/users/search-staff/" + (nidNumber || "").replace(/\s/g, "")
      //   );

      //   staff = tmisData;
      // } catch (error) {}

      const { data } = await axios.get(
        "/api/users/citizen/" + (nidNumber || "").replace(/\s/g, ""),
      );

      setTeacherForm({
        ...teacherForm,
        nidNumber: nidNumber,
        nin: data.nin,
        gender: data.gender,
        genderId: data.genderId,
        countryOfBirth: data.countryOfBirth,
        countryIdOfBirth: data.countryIdOfBirth,
        firstName: data.firstName,
        lastName: data.lastName,
        civilStatus: data.civilStatus,
        civilStatusId: data.civilStatusId,
        spouseNames: data.spouseNames,
        fatherNames: data.fatherNames,
        motherNames: data.motherNames,
        dateOfBirth: data.dateOfBirth,
        placeOfBirth: data.placeOfBirth,
        nationalityId: data.nationalityId,
        villageId: data.villageId,
        profilePicture: data.profileImage,

        employeeId: data.employee?.id || "",
        rssbNumber: data.employee?.rssbNumber || "",
        accountNumber: data.employee?.accountNumber || "",
        bankId: data.employee?.bankId || "",
        bankName: data.employee?.bankName || "",

        // employmentDateInEducation: data.employee?.employmentDateInEducation || null,

        // email: staff?.email?.trim() || "",
        // phoneNumber: staff?.phoneNumber?.trim() || "",
      });

      // setChanged(true);
      setIdHasError(false);
      setWasVerified(true);
      setIsVerifing(false);
    } catch (error) {
      // setChanged(false);
      setIdHasError(true);
      setWasVerified(false);
      setIsVerifing(false);
    }
  };

  const [profileAttachments, setProfileAttachments] = useState([]);
  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState(null);
  const [hasDisability, setHasDisability] = useState(false);

  const convertToLower = (value) => {
    return value.toLowerCase();
  };

  const isFileTooLarge = (file) => {
    const size = file.size;
    return size > 3222528 ? true : false;
  };

  const handleUploadedPDFFile = (event, document) => {
    let pdfAttachment = event.target.files[0];

    if (convertToLower(pdfAttachment?.name?.substr(-4)) !== ".pdf") {
      showError("File should be pdf format");
    } else if (isFileTooLarge(pdfAttachment)) {
      showError("Allowed file should not exceed 3MB");
    } else {
      const index = profileAttachments.findIndex(
        ({ id }) => id === document.id,
      );
      const attachments = [...profileAttachments];
      document.file = pdfAttachment;
      document.filename = pdfAttachment.name;

      const reader = new FileReader();

      reader.onload = (e) => {
        document.url = e.target.result;
      };

      reader.readAsDataURL(pdfAttachment);

      if (index < 0) attachments.push(document);
      else attachments[index] = document;

      setProfileAttachments(attachments);
    }
  };

  useEffect(() => {
    const tmp = [];

    profileDocuments.forEach((doc) => {
      tmp.push({
        id: doc.profileDocumentTypeId,
        filename: profileDocumentTypes.find(
          ({ id }) => id === doc.profileDocumentTypeId,
        )?.name,
        url: doc.filePath,
      });
    });

    setProfileAttachments(tmp);

    // Check if disability document exists to set hasDisability state
    const disabilityDoc = profileDocuments.find(
      (doc) => doc.profileDocumentTypeId === 5,
    );

    if (disabilityDoc) {
      setHasDisability(true);
    }
  }, [profileDocuments, profileDocumentTypes]);

  // Assigned Subjects State for Read-Only View
  const [teacherSubjects, setTeacherSubjects] = useState([]);
  const [teacherCertificates, setTeacherCertificates] = useState([]);
  /** Read-only: grade-by-subject is edited via Staff → Assign Subjects */
  const [placementSubjectGradesPreview, setPlacementSubjectGradesPreview] =
    useState([]);

  const getAssignedSubjects = async () => {
    if (!teacher || !teacher.teacherPlacementId) return;
    try {
      const { data } = await axios.get(
        `/api/posts/teacher-subjects/${teacher.teacherPlacementId}`,
      );
      setTeacherSubjects(data);
    } catch (error) {}
  };

  const getTeacherCertificates = async () => {
    try {
      const { data } = await axios.get(
        `/api/cpd/teacher-certificates/${teacher.userId}`,
      );
      setTeacherCertificates(data);
    } catch (error) {}
  };

  const fetchPlacementSubjectGradesPreview = async () => {
    if (!teacher?.teacherPlacementId) {
      setPlacementSubjectGradesPreview([]);
      return;
    }
    try {
      const { data } = await axios.get(
        `/api/posts/teacher-placement-subject-grades/${teacher.teacherPlacementId}`,
      );
      setPlacementSubjectGradesPreview(Array.isArray(data) ? data : []);
    } catch (error) {
      setPlacementSubjectGradesPreview([]);
    }
  };

  useEffect(() => {
    if (showDialog && teacher) {
      getAssignedSubjects();
      getTeacherCertificates();
      fetchPlacementSubjectGradesPreview();
    }
  }, [showDialog, teacher]);

  const onSave = () => {
    if (!teacherInfoFormValidator())
      addOrUpdateTeacher(
        {
          id: teacherForm.employeeId,
          lastName: teacherForm.lastName || null,
          firstName: teacherForm.firstName || null,
          email: teacherForm.email?.trim(),
          phoneNumber: teacherForm.phoneNumber?.trim(),
          nidNumber: (teacherForm.nidNumber || "").replace(/\s/g, "") || null,
          passportNumber: teacherForm.passportNumber || null,
          nin: teacherForm.nin || null,
          gender: teacherForm.genderId || null,
          dateOfBirth: teacherForm.dateOfBirth || null,
          placeOfBirth: teacherForm.placeOfBirth || null,
          fatherNames: teacherForm.fatherNames || null,
          motherNames: teacherForm.motherNames || null,
          civilStatusId: teacherForm.civilStatusId || null,
          spouseNames: teacherForm.spouseNames || null,
          countryOfBirth: teacherForm.countryIdOfBirth || null,
          nationalityId: teacherForm.nationalityId || null,
          residenceVillageId:
            village?.ippisVillageCode || teacherForm.villageId || null,
          bankId: teacherForm.bankId || null,
          bankAccountNumber: teacherForm.accountNumber || null,
          rssbNumber: teacherForm.rssbNumber || null,
          sdmsStaffCode:
            `${teacherForm.sdmsStaffCode ?? ""}`.trim() || null,
          hasEducationCertficate: teacherForm.hasEducationCertficate,
          schoolPositionId: position?.id,
          currentSchoolPositionId: teacher?.schoolPositionId || null,
          employmentTypeId: selectedEmploymentType.id,
          degreeId: selectedDegree?.id || null,
          specializationId: selectedSpecialization?.id || null,

          graduationDate: !!teacherForm.graduationDate
            ? moment(teacherForm.graduationDate).format("yyyy-MM-DD")
            : null,
          employmentDateInEducation: !!teacherForm.employmentDateInEducation
            ? moment(teacherForm.employmentDateInEducation).format("yyyy-MM-DD")
            : null,

          positionAppointmentDate: !!teacherForm.positionAppointmentDate
            ? moment(teacherForm.positionAppointmentDate).format("yyyy-MM-DD")
            : null,

          isUpdate: true,
          placementReportId: placementReport?.id || null,
          teachingLevelId: placementReport?.teachingLevelId || null,
        },
        onClose,
      );
  };

  useEffect(async () => {
    setPosition(
      schoolPositions.find(({ id }) => id === teacher.schoolPositionId),
    );
  }, [teacher, schoolPositions]);

  useEffect(async () => {
    setPosition(
      schoolPositions.find(({ id }) => id === teacher.schoolPositionId),
    );

    setSelectedEmploymentType(
      employmentTypes.find(({ id }) => id === teacher.employmentTypeId),
    );

    setSelectedDegree(degrees.find(({ id }) => id === teacher.degreeId));

    setSelectedSpecialization(
      specializations.find(({ id }) => id === teacher.specializationId),
    );

    if (!!teacher.nidNumber) {
      try {
        // const { data: tmisData } = await axios.get(
        //   "/api/users/search-staff/" +
        //     (teacher.nidNumber || "").replace(/\s/g, "")
        // );

        const { data } = await axios.get(
          "/api/users/citizen/" + (teacher.nidNumber || "").replace(/\s/g, ""),
        );

        setTeacherForm({
          ...teacherForm,
          profilePicture: data.profileImage || "",
          // employmentDate: data.employee?.employmentData || null,
          // graduationDate: tmisData.graduationDate || null,
        });

        // setSelectedDegree(
        //   degrees.find(({ id }) => id === tmisData.degreeId) ||
        //     selectedDegree ||
        //     null
        // );
        // setSelectedSpecialization(
        //   specializations.find(({ id }) => id === tmisData.specializationId) ||
        //     selectedSpecialization ||
        //     null
        // );
      } catch (error) {}
    }
  }, [teacher]);

  useEffect(() => {
    getSchoolPositions("SCHOOL", teacher.schoolId);

    if (!districts.length) getDistricts();

    if (!!teacher?.residenceDistrictId)
      getSectors(teacher?.residenceDistrictId);

    if (!!teacher?.residenceSectorId) getCells(teacher?.residenceSectorId);

    if (!!teacher?.residenceCellId) getVillages(teacher?.residenceCellId);
  }, []);

  useEffect(() => {
    if (!!district?.id) getSectors(district.id);
  }, [district]);

  useEffect(() => {
    if (!!sector?.id) getCells(sector.id);
  }, [sector]);

  useEffect(() => {
    if (!!cell?.id) getVillages(cell.id);
  }, [cell]);

  useEffect(() => {
    if (!!teacher?.residenceDistrictId && districts.length)
      setDistrict(
        districts.find((d) => d.id === teacher?.residenceDistrictId) || null,
      );
  }, [teacher, districts]);

  useEffect(() => {
    if (!!teacher?.residenceSectorId && sectors.length)
      setSector(
        sectors.find((d) => d.id === teacher?.residenceSectorId) || null,
      );
  }, [teacher, sectors]);

  useEffect(() => {
    if (!!teacher?.residenceCellId && cells.length)
      setCell(cells.find((d) => d.id === teacher?.residenceCellId) || null);
  }, [teacher, cells]);

  useEffect(() => {
    if (!!teacher?.residenceVillageId && villages.length)
      setVillage(
        villages.find(
          (v) => v.ippisVillageCode === teacher?.residenceVillageId,
        ) || null,
      );
  }, [teacher, villages]);

  const getSectors = async (districtId) => {
    try {
      const { data } = await axios.get(`/api/posts/sectors/` + districtId);
      setSectors(data);
    } catch (error) {}
  };

  const getCells = async (sectorId) => {
    try {
      const { data } = await axios.get(`/api/posts/cells/` + sectorId);
      setCells(data);
    } catch (error) {}
  };

  const getVillages = async (cellId) => {
    try {
      const { data } = await axios.get(`/api/posts/villages/` + cellId);
      setVillages(data);
    } catch (error) {}
  };

  useEffect(() => {
    getProfileDocuments(teacher.id);
  }, [teacher]);

  const getDocumentDescription = (documentId) => {
    const descriptions = {
      1: "This is a document that certifies your academic achievement. Upload your official degree certificate or diploma issued by a recognized educational institution to verify your qualification level.",
      2: "This is a document that shows your academic performance. Upload your official academic transcript that displays all courses taken, grades received, and overall academic standing during your studies.",
      3: "This is a document that confirms your employment. Upload your official appointment letter from the Ministry of Education or school administration that confirms your teaching position and employment details.",
      4: "This is a document that demonstrates your professional development. Upload your Continuous Professional Development certificate if you have completed any CPD programs, workshops, or training sessions to enhance your teaching skills.",
      5: "This is a document that certifies any special needs or accommodations. Upload documentation of any disability status if applicable, issued by relevant medical authorities or government agencies for support services.",
      6: "This is a document that evaluates your work performance. Upload your most recent performance evaluation or appraisal document from your school or education authority that assesses your teaching effectiveness and professional conduct.",
    };
    return (
      descriptions[documentId] ||
      "This is a required document. Please upload the specified document to complete your profile."
    );
  };

  useEffect(() => {
    const tmp = [];

    profileDocuments.forEach((doc) => {
      tmp.push({
        id: doc.profileDocumentTypeId,
        filename: profileDocumentTypes.find(
          ({ id }) => id === doc.profileDocumentTypeId,
        )?.name,
        url: doc.filePath,
      });
    });

    setProfileAttachments(tmp);

    // Check if disability document exists to set hasDisability state
    const disabilityDoc = profileDocuments.find(
      (doc) => doc.profileDocumentTypeId === 5,
    );
    if (disabilityDoc) {
      setHasDisability(true);
    }
  }, [profileDocuments, profileDocumentTypes]);

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle className="text-primary pb-0 mb-0 text-uppercase border">
          <span className="d-flex align-items-center mb-2">
            <Typography className="d-flex align-items-center text-primary">
              <span className="text-dark mr-1">Update Teacher Profile</span>
              {!!teacher && (
                <>
                  {teacher?.lastName} {teacher?.firstName}
                </>
              )}
            </Typography>
          </span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-0">
          <div className="mt-0" style={{ height: "100%" }}>
            <div
              style={{
                display: "table-cell",
                width: "100vw",
                height: "45vh",
                padding: "10px",
                verticalAlign: "middle",
              }}
            >
              <div className="row mx-0">
                <div className="col-sm-12">
                  <React.Fragment>
                    <div>
                      <div className="row no-gutters">
                        <div className="col-2 justify-content-center  text-center">
                          <div
                            style={{
                              minHeight: "150px",
                              overflow: "hidden",
                            }}
                          >
                            <>
                              <img
                                className="mt-0 rounded  text-center"
                                src={
                                  !!teacherForm.profilePicture
                                    ? "data:image/jpg;base64," +
                                      teacherForm.profilePicture
                                    : defaultPofile
                                }
                                style={{
                                  border: "1px solid #a7a7a7",
                                  height: "150px",
                                  width: "120px",
                                  overflow: "hidden",
                                  borderRadius: "50%",
                                }}
                              />
                            </>
                          </div>

                          <div className="text-primary">
                            <strong>NID PHOTO</strong>{" "}
                          </div>
                          <label className="text-center text-uppercase  mt-n2">
                            <span style={{ fontSize: "12px" }}>
                              {teacherForm?.lastName} {teacherForm?.firstName}
                            </span>
                          </label>

                          <FormControl
                            className="mt-3 d-block border rounded pt-2"
                            style={{
                              backgroundColor: canEditAppointmentInfo
                                ? "#eee"
                                : "#e9ecef",
                            }}
                          >
                            <FormLabel className="text-primary  px-2">
                              Education certficate
                            </FormLabel>
                            <RadioGroup
                              className="mt-0 d-flex justify-content-start px-4"
                              row
                              name="hasEducationCertficate"
                              value={teacherForm?.hasEducationCertficate}
                              onChange={(e) => {
                                setTeacherForm({
                                  ...teacherForm,
                                  hasEducationCertficate: e.target.value,
                                });

                                setErrors({
                                  ...errors,
                                  educationCertficateHasError: false,
                                });
                              }}
                            >
                              <FormControlLabel
                                value={true}
                                control={
                                  <Radio
                                    disableRipple
                                    size="small"
                                    disabled={!canEditAppointmentInfo}
                                  />
                                }
                                label="Certfied"
                              />
                              <FormControlLabel
                                value={false}
                                control={
                                  <Radio
                                    disableRipple
                                    size="small"
                                    disabled={!canEditAppointmentInfo}
                                  />
                                }
                                label="Not certfied"
                              />
                            </RadioGroup>
                            {errors.educationCertficateHasError && (
                              <small className="text-danger mb-1">
                                Select if has education certficate
                              </small>
                            )}
                          </FormControl>
                        </div>

                        <div className="col-10 row mx-0">
                          <div className="col-4 justify-content-center">
                            {!idHasError && !isVerifing && !wasVerified && (
                              <span className="material-icons loaderIcon text-danger">
                                help
                              </span>
                            )}

                            {!!isVerifing && (
                              <i
                                className="fas fa-spinner spinner loaderIcon text-primary"
                                style={{ fontSize: "22px" }}
                              ></i>
                            )}

                            {!isVerifing && !!idHasError && (
                              <span className="loaderIcon text-danger d-flex align-items-center">
                                <span className="material-icons text-danger">
                                  report_problem
                                </span>
                                <span style={{ fontSize: "10px" }}>Error</span>
                              </span>
                            )}

                            {!idHasError && !isVerifing && !!wasVerified && (
                              <span className="loaderIcon text-success d-flex align-items-center">
                                <span className="material-icons text-success ">
                                  verified
                                </span>
                                <span style={{ fontSize: "10px" }}>
                                  Verified
                                </span>
                              </span>
                            )}

                            <MaskedInput
                              mask={idNumberPattern}
                              className="form-control"
                              placeholder="NID Number"
                              guide={false}
                              value={teacherForm.nidNumber || ""}
                              onKeyPress={(e) => {
                                if (
                                  e.key === "Enter" &&
                                  !!e.target.value.length
                                ) {
                                  getNidDetails(e.target.value);
                                }
                              }}
                              onChange={(e) => {
                                setTeacherForm({
                                  ...teacherForm,
                                  nidNumber: e.target.value,
                                });

                                if (e.target.value.length === 21) {
                                  getNidDetails(e.target.value);
                                } else {
                                  setIdHasError(false);
                                  setWasVerified(false);
                                  setIsVerifing(false);
                                }
                                setErrors({
                                  ...errors,
                                  nidNumberHasError: false,
                                  passportNumberHasError: false,
                                  emailHasError: false,
                                  phoneNumberHasError: false,
                                  employeeIdHasError: false,
                                  staffCodeHasError: false,
                                  bankAccountNumberHasError: false,
                                  hasError: false,
                                });
                              }}
                            />

                            {errors.nidNumberHasError && (
                              <small className="text-danger mb-1">
                                {!!teacherForm.nidNumber
                                  ? "Invalid NID Number"
                                  : " NID Number is required"}
                              </small>
                            )}
                          </div>
                          <div className="col-4 text-left">
                            <TextField
                              fullWidth
                              size="small"
                              autoComplete="false"
                              name="passportNumber"
                              label="Passport number"
                              placeholder="Passport number"
                              variant="outlined"
                              value={teacherForm.passportNumber || ""}
                              onChange={(e) => {
                                setTeacherForm({
                                  ...teacherForm,
                                  passportNumber: e.target.value,
                                });

                                setErrors({
                                  ...errors,
                                  passportNumberHasError: false,
                                });
                              }}
                            />
                            {errors.passportNumberHasError && (
                              <small className="text-danger mt-1">
                                Passport number is required
                              </small>
                            )}
                          </div>

                          <div className="col-2 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="civilStatus"
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Civil Status"
                              variant="outlined"
                              value={teacherForm.civilStatus || ""}
                            />
                          </div>
                          <div className="col-2 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="gender"
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Gender"
                              variant="outlined"
                              className=" font-weight-bold"
                              value={teacherForm.gender || ""}
                            />
                          </div>
                          <div className="col-4  mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="lastName"
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Last Name"
                              variant="outlined"
                              className=""
                              value={teacherForm.lastName || ""}
                            />
                          </div>
                          <div className="col-4  mt-3  text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="firstName"
                              InputProps={{
                                readOnly: true,
                              }}
                              label="First Name"
                              variant="outlined"
                              className=""
                              value={teacherForm.firstName || ""}
                            />
                          </div>

                          <div className="col-4  mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="dateOfBirth"
                              value={
                                !!teacherForm.dateOfBirth
                                  ? moment(teacherForm.dateOfBirth).format(
                                      "DD/MM/yyyy",
                                    )
                                  : ""
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Date Of Birth"
                              variant="outlined"
                            />
                          </div>
                          <div className="col-4  mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="countryOfBirth"
                              value={teacherForm.countryOfBirth || ""}
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Country of Birth"
                              variant="outlined"
                              className=""
                            />
                          </div>
                          <div className="col-4  mt-3 text-left">
                            <TextField
                              InputProps={{
                                readOnly: true,
                              }}
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="placeOfBirth"
                              value={teacherForm.placeOfBirth || ""}
                              label="Place of Birth"
                              variant="outlined"
                              className=""
                            />
                          </div>

                          <div className="col-4  mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="nationality"
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Nationality"
                              placeholder="Nationality"
                              variant="outlined"
                              className=" font-weight-bold"
                              value={teacherForm.nationalityId || ""}
                            />
                          </div>

                          {canEditSdmsStaffCode && (
                            <div className="col-12 mt-2">
                              <Typography
                                variant="body2"
                                color="error"
                                sx={{
                                  bgcolor: "#ffebee",
                                  px: 1.5,
                                  py: 1,
                                  borderRadius: 1,
                                  border: "1px solid",
                                  borderColor: "error.light",
                                }}
                              >
                                You have permission to edit the{" "}
                                <strong>SDMS staff code</strong>.
                              </Typography>
                            </div>
                          )}

                          <div className="col-4 mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="employeeId"
                              value={teacherForm?.employeeId || ""}
                              InputProps={{
                                readOnly: true,
                              }}
                              label="IPPIS Employee ID"
                              placeholder="IPPIS Employee ID"
                              variant="outlined"
                            />

                            {errors.employeeIdHasError && (
                              <small className="text-danger mt-1">
                                Employee Id is required
                              </small>
                            )}
                          </div>
                          <div className="col-4 mt-3 text-left">
                            <TextField
                              style={{
                                backgroundColor: canEditSdmsStaffCode
                                  ? undefined
                                  : "#e9ecef",
                              }}
                              fullWidth
                              size="small"
                              name="sdmsStaffCode"
                              value={teacherForm?.sdmsStaffCode || ""}
                              label="SDMS staff code"
                              placeholder="SDMS staff code (TMIS mapping)"
                              variant="outlined"
                              InputProps={{
                                readOnly: !canEditSdmsStaffCode,
                              }}
                              onChange={(e) => {
                                if (!canEditSdmsStaffCode) return;
                                setTeacherForm({
                                  ...teacherForm,
                                  sdmsStaffCode: e.target.value,
                                });
                                setErrors({
                                  ...errors,
                                  staffCodeHasError: false,
                                });
                              }}
                            />

                            {errors.staffCodeHasError && (
                              <small className="text-danger mt-1">
                                Staff Code is required
                              </small>
                            )}
                          </div>

                          <div className="col-4 mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="rssbNumber"
                              value={teacherForm?.rssbNumber || ""}
                              InputProps={{
                                readOnly: true,
                              }}
                              label="RSSB Number"
                              placeholder="RSSB Number"
                              variant="outlined"
                              className=""
                            />

                            {errors.employeeIdHasError && (
                              <small className="text-danger mt-1">
                                RSSB Number is required
                              </small>
                            )}
                          </div>

                          {/* <div className="col-3  mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="employmentDate"
                              value={
                                !!teacherForm.employmentDate
                                  ? moment(teacherForm.employmentDate).format(
                                      "DD/MM/yyyy"
                                    )
                                  : ""
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Employment date in education"
                              variant="outlined"
                            />

                            {errors.employmentDateHasError && (
                              <small className="text-danger mt-1">
                                Employment date is required
                              </small>
                            )}
                          </div> */}

                          <div className="col-4 mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="bankAccount"
                              value={
                                !teacherForm.accountNumber
                                  ? ""
                                  : teacherForm.accountNumber +
                                    " (" +
                                    teacherForm.bankName +
                                    ")"
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Bank Account"
                              placeholder="Bank Account"
                              variant="outlined"
                            />

                            {!!errors.bankAccountNumberHasError && (
                              <small className="text-danger">
                                Bank account is required
                              </small>
                            )}
                          </div>

                          <div className="col-8 mt-3 ">
                            <Autocomplete
                              style={{
                                backgroundColor: canEditAppointmentInfo
                                  ? ""
                                  : "#e9ecef",
                              }}
                              readOnly={!canEditAppointmentInfo}
                              size="small"
                              defaultValue={null}
                              value={position || null}
                              options={schoolPositions}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={(option) => option.name}
                              renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                  <div>
                                    <span className="d-block text-primary">
                                      {option.name}
                                    </span>

                                    <small className="d-block mb-1 ">
                                      <span
                                        className={`badge badge badge-${
                                          +option.budgetPosts -
                                            +option.numberOfEmployees >
                                          0
                                            ? "success"
                                            : "danger"
                                        } mr-1`}
                                      >
                                        {+option.budgetPosts -
                                          +option.numberOfEmployees}{" "}
                                        Vacant
                                        {+option.budgetPosts -
                                          +option.numberOfEmployees >
                                        1
                                          ? "s"
                                          : ""}
                                      </span>
                                      /
                                      <span className="badge badge-secondary ml-1">
                                        {option.budgetPosts} Budget post
                                        {option.budgetPosts > 1 ? "s" : ""}
                                      </span>
                                    </small>
                                    <Divider />
                                    <Divider />
                                  </div>
                                </Box>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="position"
                                  label="Position"
                                  placeholder="Position"
                                  inputProps={{
                                    ...params.inputProps,
                                  }}
                                />
                              )}
                              onChange={(event, position) => {
                                setPosition(position || null);

                                setErrors({
                                  ...errors,
                                  positionHasError: false,
                                  // (!!position &&
                                  //   +position?.budgetPosts -
                                  //     +position?.numberOfEmployees >
                                  //     0) ||
                                  // position.id === teacher.schoolPositionId
                                  //   ? false
                                  //   : true,
                                });
                              }}
                            />
                            {errors.positionHasError && (
                              <small className="text-danger">
                                {!!position
                                  ? "No vacant post available"
                                  : "Position is required"}
                              </small>
                            )}
                          </div>

                          <div className="col-2 mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="qualificationLevel"
                              value={position?.qualificationLevelName || ""}
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Qualification"
                              placeholder="Qualification"
                              variant="outlined"
                            />
                          </div>

                          <div className="col-2 mt-3 text-left">
                            <TextField
                              style={{ backgroundColor: "#e9ecef" }}
                              fullWidth
                              size="small"
                              name="teachingLevel"
                              value={
                                positionTeachingLevelName(position) ||
                                teacher.teachingLevelName ||
                                ""
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                              label="Teaching Level"
                              placeholder="Teaching Level"
                              variant="outlined"
                            />
                          </div>

                          <div className="col-4 mt-3 ">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DesktopDatePicker
                                readOnly={!canEditAppointmentInfo}
                                label="Position appointment date"
                                placeholder="Position appointment date"
                                inputFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                value={
                                  teacherForm.positionAppointmentDate || null
                                }
                                onChange={(date) => {
                                  setTeacherForm({
                                    ...teacherForm,
                                    positionAppointmentDate: date,
                                  });

                                  setErrors({
                                    ...errors,
                                    positionAppointmentDateHasError: false,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    style={{
                                      backgroundColor: canEditAppointmentInfo
                                        ? ""
                                        : "#e9ecef",
                                    }}
                                    size="small"
                                    fullWidth
                                    {...params}
                                  />
                                )}
                              />

                              {errors.positionAppointmentDateHasError && (
                                <small className="text-danger mt-1">
                                  {!!teacherForm.positionAppointmentDate
                                    ? "Invalid date"
                                    : "Position appointment date is required"}
                                </small>
                              )}
                            </LocalizationProvider>
                          </div>

                          <div className="col-4 mt-3 ">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DesktopDatePicker
                                readOnly={!canEditAppointmentInfo}
                                label="Employment date in education"
                                placeholder="Employment date in education"
                                inputFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                value={
                                  teacherForm.employmentDateInEducation || null
                                }
                                onChange={(date) => {
                                  setTeacherForm({
                                    ...teacherForm,
                                    employmentDateInEducation: date,
                                  });

                                  setErrors({
                                    ...errors,
                                    employmentDateInEducationHasError: false,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    style={{
                                      backgroundColor: !canEditAppointmentInfo
                                        ? "#e9ecef"
                                        : "",
                                    }}
                                    size="small"
                                    fullWidth
                                    {...params}
                                  />
                                )}
                              />

                              {errors.employmentDateInEducationHasError && (
                                <small className="text-danger mt-1">
                                  Invalid date
                                </small>
                              )}
                            </LocalizationProvider>
                          </div>

                          <div className="col-4  mt-3 text-left">
                            <TextField
                              fullWidth
                              size="small"
                              autoComplete="false"
                              name="phone"
                              label="Phone number"
                              placeholder="Phone number"
                              variant="outlined"
                              value={teacherForm.phoneNumber || ""}
                              onChange={(e) => {
                                setTeacherForm({
                                  ...teacherForm,
                                  phoneNumber: e.target.value,
                                });

                                setErrors({
                                  ...errors,
                                  phoneNumberHasError: false,
                                });
                              }}
                            />
                            {errors.phoneNumberHasError && (
                              <small className="text-danger mt-1">
                                {!!teacherForm.phoneNumber
                                  ? "Invalid Phone Number"
                                  : " Phone Number is required"}
                              </small>
                            )}
                          </div>

                          <div className="col-4  mt-3 text-left">
                            <TextField
                              fullWidth
                              size="small"
                              autoComplete="false"
                              name="email"
                              label="Personal email"
                              placeholder="Personal email"
                              variant="outlined"
                              value={teacherForm.email || ""}
                              onChange={(e) => {
                                setTeacherForm({
                                  ...teacherForm,
                                  email: e.target.value,
                                });
                                setErrors({
                                  ...errors,
                                  emailHasError: false,
                                });
                              }}
                            />

                            {errors.emailHasError && (
                              <small className="text-danger">
                                {!!teacherForm.email
                                  ? "Invalid Personal email"
                                  : " Personal email is required"}
                              </small>
                            )}
                          </div>

                          <div className="mt-3 col-4">
                            <Autocomplete
                              size="small"
                              defaultValue={null}
                              value={selectedEmploymentType}
                              options={employmentTypes}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={(option) => option.name}
                              renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                  {option.name}
                                </Box>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="employmentType"
                                  label="Employment Type"
                                  placeholder="Employment Type"
                                  inputProps={{
                                    ...params.inputProps,
                                  }}
                                />
                              )}
                              onChange={(event, employmentType) => {
                                setSelectedEmploymentType(
                                  employmentType || null,
                                );

                                setErrors({
                                  ...errors,
                                  employmentTypeHasError: false,
                                });
                              }}
                            />
                            {errors.employmentTypeHasError && (
                              <small className="text-danger">
                                Employment Type is required
                              </small>
                            )}
                          </div>

                          <div className="mt-3 col-4">
                            <Autocomplete
                              size="small"
                              defaultValue={null}
                              value={selectedDegree}
                              options={degrees}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={(option) => option.name}
                              renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                  {option.name}
                                </Box>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Highest Degree"
                                  name="degree"
                                  placeholder="Highest Degree"
                                  inputProps={{
                                    ...params.inputProps,
                                  }}
                                />
                              )}
                              onChange={(event, degree) => {
                                setSelectedDegree(degree || null);

                                setErrors({
                                  ...errors,
                                  degreeHasError: false,
                                });
                              }}
                            />
                            {errors.degreeHasError && (
                              <small className="text-danger">
                                Highest Degree is required
                              </small>
                            )}
                          </div>
                          <div className="mt-3 col-4">
                            <Autocomplete
                              size="small"
                              defaultValue={null}
                              value={selectedSpecialization}
                              options={specializations}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={(option) => option.name}
                              renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                  {option.name}
                                </Box>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Specialization"
                                  name="specialization"
                                  placeholder="Specialization"
                                  inputProps={{
                                    ...params.inputProps,
                                  }}
                                />
                              )}
                              onChange={(event, specialization) => {
                                setSelectedSpecialization(
                                  specialization || null,
                                );

                                setErrors({
                                  ...errors,
                                  specializationHasError: false,
                                });
                              }}
                            />
                            {errors.specializationHasError && (
                              <small className="text-danger">
                                Specialization is required
                              </small>
                            )}
                          </div>
                          <div className="mt-3 col-4">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DesktopDatePicker
                                label="Graduation date"
                                inputFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                value={teacherForm.graduationDate || null}
                                onChange={(date) => {
                                  setTeacherForm({
                                    ...teacherForm,
                                    graduationDate: date,
                                  });

                                  setErrors({
                                    ...errors,
                                    graduationDateHasError: false,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    size="small"
                                    fullWidth
                                    {...params}
                                  />
                                )}
                              />

                              {errors.graduationDateHasError && (
                                <small className="text-danger mt-1">
                                  {!!teacherForm.graduationDate
                                    ? "Invalid Date"
                                    : "Graduation Date is required"}
                                </small>
                              )}
                            </LocalizationProvider>
                          </div>

                          <div className="col-12">
                            <fieldset
                              // style={{ backgroundColor: "#ccefff75" }}
                              className={`mx-0 row p-3 mt-2 rounded  border bg-white elevated justify-content-center`}
                            >
                              <legend
                                className={`col-12 w-auto px-2 text-primary`}
                                style={{
                                  fontFamily:
                                    '"Roboto","Helvetica","Arial",sans-serif',
                                  fontWeight: 400,
                                  fontSize: "0.82rem",
                                  lineHeight: "1em",
                                  letterSpacing: "0.00938em",
                                }}
                              >
                                Physical address{" "}
                                {!!teacher.isProfileLocked && (
                                  <Tooltip title="Updated">
                                    <span className="text-success">
                                      <DoneAllIcon />
                                    </span>
                                  </Tooltip>
                                )}
                              </legend>

                              <div className="col-12 col-md-6 mb-2 mt-2">
                                <Autocomplete
                                  size="small"
                                  defaultValue={null}
                                  value={district}
                                  options={districts || []}
                                  disabled={loading}
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  onChange={(event, district) => {
                                    setDistrict(district || null);

                                    setSector(null);
                                    setCell(null);
                                    setVillage(null);

                                    setSectors([]);
                                    setCells([]);
                                    setVillages([]);
                                  }}
                                  getOptionLabel={(option) => option.name || ""}
                                  renderOption={(props, district) => (
                                    <Box
                                      component="li"
                                      {...props}
                                      key={district.id}
                                    >
                                      {district.name}
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      style={{
                                        height: "25px !important",
                                        position: "relative",
                                        borderRadius: "8px",
                                        padding: "1px !important",
                                      }}
                                      {...params}
                                      label="Residence district"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "name", // disable autocomplete and autofill
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              <div className="col-12 col-md-6 mb-2 mt-2">
                                <Autocomplete
                                  size="small"
                                  defaultValue={null}
                                  value={sector}
                                  options={sectors}
                                  disabled={loading || !sectors.length}
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  onChange={(event, sector) => {
                                    setSector(sector || null);

                                    setCell(null);
                                    setVillage(null);

                                    setCells([]);
                                    setVillages([]);
                                  }}
                                  getOptionLabel={(option) => option.name || ""}
                                  renderOption={(props, sector) => (
                                    <Box
                                      component="li"
                                      {...props}
                                      key={sector.id}
                                    >
                                      {sector.name}
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      style={{
                                        height: "25px !important",
                                        position: "relative",
                                        borderRadius: "8px",
                                        padding: "1px !important",
                                      }}
                                      {...params}
                                      label="Residence sector"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "name", // disable autocomplete and autofill
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              <div className="col-12 col-md-6 mb-2 mt-2">
                                <Autocomplete
                                  size="small"
                                  defaultValue={null}
                                  value={cell || null}
                                  options={cells}
                                  disabled={loading || !cells.length}
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  onChange={(event, cell) => {
                                    setCell(cell || null);
                                    setVillage(null);
                                    setVillages([]);
                                  }}
                                  getOptionLabel={(option) => option.name || ""}
                                  renderOption={(props, cell) => (
                                    <Box
                                      component="li"
                                      {...props}
                                      key={cell.id}
                                    >
                                      {cell.name}
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      style={{
                                        height: "25px !important",
                                        position: "relative",
                                        borderRadius: "8px",
                                        padding: "1px !important",
                                      }}
                                      {...params}
                                      label="Residence cell"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "name", // disable autocomplete and autofill
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              <div className="col-12 col-md-6 mb-2 mt-2">
                                <Autocomplete
                                  size="small"
                                  defaultValue={null}
                                  value={village || null}
                                  options={villages.filter(
                                    (v) => !!v.ippisVillageCode,
                                  )}
                                  disabled={loading || !villages.length}
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  onChange={(event, village) =>
                                    setVillage(village || null)
                                  }
                                  getOptionLabel={(option) => option.name || ""}
                                  renderOption={(props, village) => (
                                    <Box
                                      component="li"
                                      {...props}
                                      key={village.id}
                                    >
                                      {village.name}
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      style={{
                                        height: "25px !important",
                                        position: "relative",
                                        borderRadius: "8px",
                                        padding: "1px !important",
                                      }}
                                      {...params}
                                      label="Residence village"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "name", // disable autocomplete and autofill
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </fieldset>
                          </div>
                        </div>

                        <div
                          className="col-12 row no-gutters mx-0 mb-3 mt-3"
                          // style={{ backgroundColor: "#ccefff75" }}
                        >
                          <div className="col-12 px-3 mt-2">
                            <fieldset
                              className={`row elevated rounded bg-light border align-items-end p-3`}
                            >
                              <legend
                                className={`col-12 w-auto px-2 text-primary`}
                                style={{
                                  fontFamily:
                                    '"Roboto","Helvetica","Arial",sans-serif',
                                  fontWeight: 400,
                                  fontSize: "0.82rem",
                                  lineHeight: "1em",
                                  letterSpacing: "0.00938em",
                                }}
                              >
                                Assigned Subjects
                              </legend>

                              <div className="col-12">
                                <table className="table table-sm table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Level</th>
                                      <th>Class</th>
                                      <th>Subject</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {teacherSubjects.map((ts) => (
                                      <tr key={ts.id}>
                                        <td>
                                          {
                                            ts.schoolSubLevelSubject
                                              ?.schoolSubLevel?.schoolLevel
                                              ?.name
                                          }
                                        </td>
                                        <td>
                                          {
                                            ts.schoolSubLevelSubject
                                              ?.schoolSubLevel?.name
                                          }
                                        </td>
                                        <td>
                                          {
                                            ts.schoolSubLevelSubject?.subject
                                              ?.name
                                          }
                                        </td>
                                      </tr>
                                    ))}
                                    {teacherSubjects.length === 0 && (
                                      <tr>
                                        <td colSpan="3" className="text-center">
                                          No subjects assigned
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>

                              <div className="col-12 mt-3">
                                <Typography
                                  variant="subtitle2"
                                  color="primary"
                                  className="mb-2"
                                >
                                  Grades taught by subject
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  display="block"
                                  className="mb-2"
                                >
                                  Edited from the staff list using Assign
                                  Subjects (head teacher or users with subject
                                  assignment rights).
                                </Typography>

                                {placementSubjectGradesPreview.length > 0 ? (
                                  <table className="table table-sm table-bordered mt-1">
                                    <thead>
                                      <tr>
                                        <th>Level</th>
                                        <th>Class</th>
                                        <th>Subject</th>
                                        <th>Grades</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {placementSubjectGradesPreview.map(
                                        (row) => (
                                          <tr
                                            key={
                                              row.teacherSubjectId ??
                                              `${row.subjectId}-${row.schoolSubLevelName}`
                                            }
                                          >
                                            <td>{row.schoolLevelName || "—"}</td>
                                            <td>
                                              {row.schoolSubLevelName || "—"}
                                            </td>
                                            <td>
                                              {row.subjectName ||
                                                row.subjectId ||
                                                "—"}
                                            </td>
                                            <td>
                                              {(row.classGrades || [])
                                                .map((g) => g.code)
                                                .join(", ") || "—"}
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    No class grades recorded for subjects.
                                  </Typography>
                                )}
                              </div>

                              <div className="col-12">
                                <div
                                  className="px-4 py-2 "
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    border: "1px solid #cfd3d8",
                                  }}
                                >
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          disabled={!teacher.isCpdCoordinator}
                                          className="py-0"
                                          checked={teacher.isCpdCoordinator}
                                        />
                                      }
                                      label="Is CPD Coordinator"
                                    />
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          disabled={!teacher.isIEFT}
                                          className="py-0"
                                          checked={teacher.isIEFT}
                                        />
                                      }
                                      label="Is Inclusive Education Focal Teacher (IEFT)"
                                    />

                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          disabled={
                                            !teacher.mentorshipSubjectId
                                          }
                                          className="py-0"
                                          checked={
                                            !!teacher.mentorshipSubjectId
                                          }
                                        />
                                      }
                                      label="Is School Subject Mentor(SSM)"
                                    />
                                  </FormGroup>

                                  {!!teacher.mentorshipSubjectId && (
                                    <TextField
                                      className="mt-2"
                                      InputProps={{ readOnly: true }}
                                      fullWidth
                                      size="small"
                                      autoComplete="false"
                                      name="schoolMentorSubject"
                                      label="School mentor subjects"
                                      placeholder="School mentor subjects"
                                      variant="outlined"
                                      value={
                                        teacher.mentorshipSubjectName || ""
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </fieldset>
                          </div>

                          {!!teacherCertificates.length && (
                            <div className="col-12 px-3 mt-3">
                              <fieldset
                                className={`elevated row rounded bg-light form-group border align-items-end p-3`}
                              >
                                <legend
                                  className={`col-12 w-auto px-2 text-primary`}
                                  style={{
                                    fontFamily:
                                      '"Roboto","Helvetica","Arial",sans-serif',
                                    fontWeight: 400,
                                    fontSize: "0.82rem",
                                    lineHeight: "1em",
                                    letterSpacing: "0.00938em",
                                  }}
                                >
                                  Mandatory certificates
                                </legend>

                                <div className="col-12">
                                  <table className="table table-sm table-bordered">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {teacherCertificates.map(
                                        (cert, index) => (
                                          <tr key={cert.id}>
                                            <td>{index + 1}</td>
                                            <td>{cert.id}</td>
                                            <td>{cert.name}</td>
                                            <td
                                              className={`text-${!!cert.taken ? "success" : "danger"}`}
                                            >
                                              {!!cert.taken
                                                ? "Taken"
                                                : "Not taken"}
                                            </td>
                                            <td>{/* {cert.status} */}</td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </fieldset>
                            </div>
                          )}

                          <div className="col-12 p-3 mt-2 border elevated rounded bg-light">
                            <fieldset
                              className={` row mx-0 rounded bg-light form-group border align-items-end`}
                            >
                              <legend
                                className={`col-12 w-auto px-2 text-primary`}
                                style={{
                                  fontFamily:
                                    '"Roboto","Helvetica","Arial",sans-serif',
                                  fontWeight: 400,
                                  fontSize: "0.82rem",
                                  lineHeight: "1em",
                                  letterSpacing: "0.00938em",
                                }}
                              >
                                Profile documents
                              </legend>

                              {profileDocumentTypes?.map((document) => {
                                if (document.id === 5) {
                                  return (
                                    <div className="col-6" key={document.id}>
                                      <fieldset className={`form-groupborder`}>
                                        <legend
                                          className="w-auto px-2 d-flex align-items-center"
                                          style={{
                                            fontFamily:
                                              '"Roboto","Helvetica","Arial",sans-serif',
                                            fontWeight: 400,
                                            fontSize: "0.82rem",
                                            lineHeight: "1em",
                                            letterSpacing: "0.00938em",
                                            color: `rgba(0, 0, 0, 0.6)`,
                                          }}
                                        >
                                          {document.id}.{" "}
                                          <span className="ml-1">
                                            Do you have any disability?
                                          </span>
                                        </legend>

                                        <div className="form-group1 mb-3 pr-4">
                                          <div className="w-100">
                                            <RadioGroup
                                              row
                                              value={hasDisability}
                                              className="mt-2 ml-4"
                                            >
                                              <FormControlLabel
                                                value={true}
                                                control={<Radio size="small" />}
                                                label="Yes"
                                              />
                                              <FormControlLabel
                                                value={false}
                                                control={<Radio size="small" />}
                                                label="No"
                                              />
                                            </RadioGroup>

                                            {hasDisability && (
                                              <div className="ml-3 w-100">
                                                <legend
                                                  className="w-auto d-flex align-items-center mb-2"
                                                  style={{
                                                    fontFamily:
                                                      '"Roboto","Helvetica","Arial",sans-serif',
                                                    fontWeight: 400,
                                                    fontSize: "0.82rem",
                                                    lineHeight: "1em",
                                                    letterSpacing: "0.00938em",
                                                    color: `rgba(0, 0, 0, 0.6)`,
                                                  }}
                                                >
                                                  <span>
                                                    Upload disability
                                                    documentation
                                                  </span>
                                                  <Tooltip
                                                    title="This is a document that certifies any special needs or accommodations. Upload documentation of any disability status if applicable, issued by relevant medical authorities or government agencies for support services."
                                                    placement="top"
                                                    arrow
                                                    enterDelay={200}
                                                    leaveDelay={200}
                                                    componentsProps={{
                                                      tooltip: {
                                                        sx: {
                                                          bgcolor:
                                                            "rgba(33, 33, 33, 0.95)",
                                                          color: "white",
                                                          fontSize: "0.875rem",
                                                          fontWeight: 400,
                                                          lineHeight: 1.4,
                                                          padding: "12px 16px",
                                                          borderRadius: "8px",
                                                          maxWidth: "320px",
                                                          boxShadow:
                                                            "0 4px 12px rgba(0, 0, 0, 0.15)",
                                                          border:
                                                            "1px solid rgba(255, 255, 255, 0.1)",
                                                          backdropFilter:
                                                            "blur(8px)",
                                                          "& .MuiTooltip-arrow":
                                                            {
                                                              color:
                                                                "rgba(33, 33, 33, 0.95)",
                                                            },
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    <Help
                                                      fontSize="small"
                                                      style={{
                                                        marginLeft: "6px",
                                                        marginBottom: "2px",
                                                        color: "grey",
                                                        cursor: "pointer",
                                                        transition:
                                                          "all 0.2s ease-in-out",
                                                      }}
                                                    />
                                                  </Tooltip>
                                                </legend>
                                                <div className="input-group w-100">
                                                  <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                      <i className="fas fa-paperclip"></i>
                                                    </span>
                                                  </div>
                                                  {profileAttachments.find(
                                                    (doc) =>
                                                      doc.id === 5 &&
                                                      !!doc.filename,
                                                  ) ? (
                                                    <div
                                                      className="form-control"
                                                      style={{
                                                        backgroundColor:
                                                          "rgb(229, 246, 253)",
                                                        color: "#007bff",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                          setShowUploadedDocument(
                                                            true,
                                                          );
                                                          setUploadedDocument({
                                                            name: "Disability Documentation",
                                                            url: profileAttachments.find(
                                                              (doc) =>
                                                                doc.id === 5 &&
                                                                !!doc.filename,
                                                            ).url,
                                                          });
                                                        }}
                                                      >
                                                        {
                                                          profileAttachments.find(
                                                            (doc) =>
                                                              doc.id === 5 &&
                                                              !!doc.filename,
                                                          ).filename
                                                        }
                                                      </span>
                                                    </div>
                                                  ) : (
                                                    <span className="ml-2 text-danger">
                                                      No file uploaded
                                                    </span>
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                  );
                                }

                                return (
                                  <DocumentItem
                                    key={document.id}
                                    document={document}
                                    profileAttachments={profileAttachments}
                                    setProfileAttachments={
                                      setProfileAttachments
                                    }
                                    setShowUploadedDocument={
                                      setShowUploadedDocument
                                    }
                                    setUploadedDocument={setUploadedDocument}
                                    handleUploadedPDFFile={
                                      handleUploadedPDFFile
                                    }
                                    getDocumentDescription={
                                      getDocumentDescription
                                    }
                                  />
                                );
                              })}
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        {canSaveStaffChanges && (
          <DialogActions className=" d-flex justify-content-center py-4">
            <Button
              disabled={loading}
              color="primary"
              variant="contained"
              disableElevation
              size="sm"
              className="px-5"
              onClick={onSave}
            >
              {loading ? "Wait..." : "Save Changes"}
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {showUploadedDocument && uploadedDocument && (
        <PreviewPdfUrl
          isBase64={true}
          showDocument={showUploadedDocument}
          setShowDocument={setShowUploadedDocument}
          document={{
            name: `${uploadedDocument?.name || ""}`,
            url: uploadedDocument?.url || "",
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  onWait,
  placementReportDetails,
  changeList,
  prevPlacementReport,
  signatories,
  roles,
  districts,
  degrees,
  specializations,
  schoolPositions,
  profileDocuments,
  profileDocumentTypes,
  schoolTeachers, // Assuming schoolTeachers is in the root state
}) => {
  return {
    user,
    loading,
    onWait,
    placementReportDetails,
    changeList,
    prevPlacementReport,
    signatories,
    roles,
    districts,
    degrees,
    specializations,
    schoolPositions,
    profileDocuments,
    profileDocumentTypes,
    schoolTeachers: schoolTeachers || [],
  };
};
export default connect(mapStateToProps, {
  addOrUpdateTeacher,
  getSchoolPositions,
  getDistricts,
  getProfileDocuments,
  getShoolTeachers,
})(UpdateTeacherDialog);

const DocumentItem = (props) => {
  const {
    document,
    profileAttachments,
    setProfileAttachments,
    setShowUploadedDocument,
    setUploadedDocument,
    handleUploadedPDFFile,
    getDocumentDescription,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="col-6" key={document.id}>
        <fieldset className={`form-groupborder px-2`}>
          <legend
            className="w-auto px-2 d-flex align-items-center"
            style={{
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: 400,
              fontSize: "0.82rem",
              lineHeight: "1em",
              letterSpacing: "0.00938em",
              color: `rgba(0, 0, 0, 0.6)`,
            }}
          >
            {document.id}. <span className="ml-1">{document.name}</span>
            <Tooltip
              title={getDocumentDescription(document.id)}
              placement="top"
              arrow
              enterDelay={200}
              leaveDelay={200}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "rgba(33, 33, 33, 0.95)",
                    color: "white",
                    fontSize: "0.875rem",
                    fontWeight: 400,
                    lineHeight: 1.4,
                    padding: "12px 16px",
                    borderRadius: "8px",
                    maxWidth: "320px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(8px)",
                    "& .MuiTooltip-arrow": {
                      color: "rgba(33, 33, 33, 0.95)",
                    },
                  },
                },
              }}
            >
              <Help
                fontSize="small"
                style={{
                  marginLeft: "6px",
                  marginBottom: "2px",
                  color: "grey",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                }}
              />
            </Tooltip>
          </legend>
          <div className="form-group1 mb-3">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fas fa-paperclip"></i>
                </span>
              </div>
              {profileAttachments.find(
                (doc) => document.id === doc.id && !!doc.filename,
              ) ? (
                <div
                  className="form-control"
                  style={{
                    backgroundColor: "rgb(229, 246, 253)",
                    color: "#007bff",
                  }}
                >
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowUploadedDocument(true);
                      setUploadedDocument({
                        name: document.name,
                        url: profileAttachments.find(
                          (doc) => document.id === doc.id && !!doc.filename,
                        ).url,
                      });
                    }}
                  >
                    {
                      profileAttachments.find(
                        (doc) => document.id === doc.id && !!doc.filename,
                      ).filename
                    }
                  </span>
                </div>
              ) : (
                <>
                  <span className="ml-2 text-danger">No file uploaded</span>
                </>
              )}
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};
